/* =========================
   ASILI SIZE CHART MODULE
   - product-page proxy positioning/opening
   - dynamic popup rendering
   - standalone page rendering
   ========================= */
(() => {
  if (window.__asiliSizeChartModuleInit) return;
  window.__asiliSizeChartModuleInit = true;

  const CONFIG = {
    images: {
      g64000: 'https://cdn.shopify.com/s/files/1/0944/8833/0585/files/Gildan64000_Unisex_Black_SZ.png?v=1776560216',
      g18500: 'https://cdn.shopify.com/s/files/1/0944/8833/0585/files/18500_Black_flat_SZ.png?v=1776560217',
      g18000: 'https://cdn.shopify.com/s/files/1/0944/8833/0585/files/18000_Black_flat_SZ.png?v=1776560216',
      g2400: 'https://cdn.shopify.com/s/files/1/0944/8833/0585/files/G2400_black_front_SZ.png?v=1776560217',
    },
  };

  window.ASILI_SIZE_CHART_CONFIG = window.ASILI_SIZE_CHART_CONFIG || CONFIG;

  const PRODUCT_INFO_SELECTOR = '.product__info-container';
  const PRICE_SELECTOR = '.price, [data-price], .product__price';
  const Y_NUDGE = -21;
  const PRICE_PULL_UP = 24;

  const TRIGGER_SELECTORS = [
    '.product-popup-modal__button',
    '.product-popup-modal__open',
    '.size-chart-link',
    '[aria-controls*="size"]',
    '[data-popup*="size"]',
    '[data-target*="size"]',
  ];

  const PROFILE_TO_CHART = {
    tee_front_basic: 'g64000',
    tee_front_back: 'g64000',
    hoodie_front_basic: 'g18500',
    sweatshirt_front_basic: 'g18000',
    longsleeve_front_basic: 'g2400',
  };

  const SIZE_CHARTS = {
    g64000: {
      title: 'Gildan 64000 T-Shirt',
      rows: [
        { size: 'S', width: 18.00, length: 28.00 },
        { size: 'M', width: 20.00, length: 29.00 },
        { size: 'L', width: 22.00, length: 30.00 },
        { size: 'XL', width: 24.00, length: 31.00 },
        { size: '2XL', width: 26.00, length: 32.00 },
        { size: '3XL', width: 28.00, length: 33.00 },
      ],
    },

    g18500: {
      title: 'Gildan 18500 Hoodie',
      rows: [
        { size: 'S', width: 20.00, length: 27.00 },
        { size: 'M', width: 22.00, length: 28.00 },
        { size: 'L', width: 24.00, length: 29.00 },
        { size: 'XL', width: 26.00, length: 30.00 },
        { size: '2XL', width: 28.00, length: 31.00 },
        { size: '3XL', width: 30.00, length: 32.00 },
      ],
    },

    g18000: {
      title: 'Gildan 18000 Sweatshirt',
      rows: [
        { size: 'S', width: 20.00, length: 27.00 },
        { size: 'M', width: 22.00, length: 28.00 },
        { size: 'L', width: 24.00, length: 29.00 },
        { size: 'XL', width: 26.00, length: 30.00 },
        { size: '2XL', width: 28.00, length: 31.00 },
        { size: '3XL', width: 30.00, length: 32.00 },
      ],
    },

    g2400: {
      title: 'Gildan 2400 Longsleeve',
      rows: [
        { size: 'S', width: 18.00, length: 28.00 },
        { size: 'M', width: 20.00, length: 29.00 },
        { size: 'L', width: 22.00, length: 30.00 },
        { size: 'XL', width: 24.00, length: 31.00 },
        { size: '2XL', width: 26.00, length: 32.00 },
        { size: '3XL', width: 28.00, length: 33.00 },
      ],
    },
  };

  const SIZE_CHART_IMAGES = window.ASILI_SIZE_CHART_CONFIG?.images || CONFIG.images;

  const SIZE_CHART_TIPS = {
    default: 'This is a regular fit. If you want a slimmer fit, consider going one size down.',
    g18500: 'This is a regular fit. If you want a more relaxed fit, consider going one size up.',
    g18000: 'This is a regular fit. If you want a more relaxed fit, consider going one size up.',
  };

  const STORAGE_KEY = 'asili_size_chart_unit';

  const onReady = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const getPreferredUnit = () => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'cm' ? 'cm' : 'in';
    } catch (error) {
      return 'in';
    }
  };

  const setPreferredUnit = (unit) => {
    try {
      localStorage.setItem(STORAGE_KEY, unit);
    } catch (error) {}
  };

  const formatMeasure = (valueInInches, unit) => {
    if (unit === 'cm') return (Math.round(valueInInches * 2.54 * 10) / 10).toFixed(1);
    return Number.isInteger(valueInInches) ? valueInInches.toFixed(0) : valueInInches.toFixed(2);
  };

  const findTrigger = (info) => {
    if (!info) return null;
    for (const selector of TRIGGER_SELECTORS) {
      const el = info.querySelector(selector);
      if (el) return el;
    }

    const candidates = info.querySelectorAll('a, button, summary');
    return Array.from(candidates).find((el) => /size\s*chart/i.test((el.textContent || '').trim())) || null;
  };

  const hideOnlyTrigger = (trigger) => {
    if (!trigger) return;
    const popupWrap = trigger.closest('.product-popup-modal');
    if (popupWrap) {
      popupWrap.style.display = 'none';
      return;
    }
    trigger.style.display = 'none';
    trigger.setAttribute('aria-hidden', 'true');
    trigger.tabIndex = -1;
  };

  const ensureProxyInInfo = (info, proxy) => {
    if (proxy.parentElement !== info) info.appendChild(proxy);
    if (getComputedStyle(info).position === 'static') info.style.position = 'relative';
  };

  const directChildBlock = (el, container) => {
    let cur = el;
    while (cur && cur.parentElement && cur.parentElement !== container) cur = cur.parentElement;
    return cur && cur.parentElement === container ? cur : null;
  };

  let proxyDebounce = null;

  const positionProxy = () => {
    const info = document.querySelector(PRODUCT_INFO_SELECTOR);
    const proxy = document.getElementById('asiliSizeChartProxy');
    if (!info || !proxy) return;

    const priceEl = info.querySelector(PRICE_SELECTOR);
    if (!priceEl) {
      proxy.style.display = 'none';
      return;
    }

    ensureProxyInInfo(info, proxy);

    const priceBlock = directChildBlock(priceEl, info);
    if (priceBlock) priceBlock.style.marginTop = `${-PRICE_PULL_UP}px`;

    const trigger = findTrigger(info);
    hideOnlyTrigger(trigger);

    proxy.style.display = 'inline-flex';
    proxy.style.right = '0px';
    proxy.style.top = '0px';

    requestAnimationFrame(() => {
      const infoRect = info.getBoundingClientRect();
      const priceRect = priceEl.getBoundingClientRect();
      const proxyRect = proxy.getBoundingClientRect();

      const rightOffset = Math.max(0, infoRect.right - priceRect.right);
      proxy.style.right = `${rightOffset}px`;

      const topOffset = priceRect.bottom - infoRect.top - proxyRect.height + Y_NUDGE;
      proxy.style.top = `${topOffset}px`;

      priceEl.style.paddingRight = `${Math.ceil(proxyRect.width + 12)}px`;

      const fs = getComputedStyle(priceEl).fontSize;
      if (fs) proxy.style.fontSize = fs;
    });
  };

  const openSizeChart = () => {
    const info = document.querySelector(PRODUCT_INFO_SELECTOR);
    if (!info) return;
    const trigger = findTrigger(info);
    if (trigger) trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  };

  const scheduleProxyPosition = () => {
    clearTimeout(proxyDebounce);
    document.documentElement.classList.add('asili-variant-changing');

    proxyDebounce = setTimeout(() => {
      positionProxy();
      setTimeout(positionProxy, 250);

      setTimeout(() => {
        document.documentElement.classList.remove('asili-variant-changing');
      }, 600);
    }, 50);
  };

  const readSizeChartContext = () => {
    const ctx = document.getElementById('asiliSizeChartContext');

    return {
      sizeChartKey: (ctx?.dataset.sizeChartKey || '').trim().toLowerCase(),
      asiliProfileKey: (ctx?.dataset.asiliProfileKey || '').trim().toLowerCase(),
      productType: (ctx?.dataset.productType || '').trim().toLowerCase(),
      productTitle: (ctx?.dataset.productTitle || '').trim().toLowerCase(),
      productHandle: (ctx?.dataset.productHandle || '').trim().toLowerCase(),
      productTags: (ctx?.dataset.productTags || '').trim(),
    };
  };

  const extractProfileKeysFromTags = (tagsRaw) => {
    if (!tagsRaw) return [];
    return tagsRaw
      .split('||')
      .map((tag) => tag.trim())
      .filter(Boolean)
      .map((tag) => {
        if (tag.includes('ASILI_PRODUCT_KEY_') && tag.includes('__')) return tag.split('__').pop().trim().toLowerCase();
        return '';
      })
      .filter(Boolean);
  };

  const fallbackChartFromSignals = (signals) => {
    const signal = signals.join(' ').toLowerCase();

    if (signal.includes('longsleeve_front_basic') || signal.includes('long sleeve') || signal.includes('longsleeve') || signal.includes('g2400')) return 'g2400';
    if (signal.includes('hoodie_front_basic') || signal.includes('hoodie') || signal.includes('g18500')) return 'g18500';
    if (signal.includes('sweatshirt_front_basic') || signal.includes('sweatshirt') || signal.includes('crewneck') || signal.includes('g18000')) return 'g18000';
    if (signal.includes('tee_front_basic') || signal.includes('tee_front_back') || signal.includes('t-shirt') || signal.includes('t shirt') || signal.includes('tee') || signal.includes('g64000') || signal.includes('64k')) return 'g64000';

    return 'g64000';
  };

  const resolveChartKey = (root) => {
    const staticKey = (root?.dataset?.sizeChartStaticKey || '').trim().toLowerCase();
    if (staticKey && SIZE_CHARTS[staticKey]) return staticKey;

    const { sizeChartKey, asiliProfileKey, productType, productTitle, productHandle, productTags } = readSizeChartContext();

    if (sizeChartKey && SIZE_CHARTS[sizeChartKey]) return sizeChartKey;
    if (asiliProfileKey && PROFILE_TO_CHART[asiliProfileKey]) return PROFILE_TO_CHART[asiliProfileKey];

    const profileKeysFromTags = extractProfileKeysFromTags(productTags);
    for (const key of profileKeysFromTags) {
      if (PROFILE_TO_CHART[key]) return PROFILE_TO_CHART[key];
    }

    return fallbackChartFromSignals([productType, productTitle, productHandle, productTags, ...profileKeysFromTags]);
  };

  const renderSizeChart = (root) => {
    const key = resolveChartKey(root);
    const unit = root.dataset.unit || getPreferredUnit();
    const chart = SIZE_CHARTS[key] || SIZE_CHARTS.g64000;

    const modelEl = root.querySelector('[data-sc-model]');
    const tbody = root.querySelector('[data-sc-tbody]');
    const colWidth = root.querySelector('[data-col-width]');
    const colLength = root.querySelector('[data-col-length]');
    const imageWrap = root.querySelector('[data-sc-imagewrap]');
    const imageEl = root.querySelector('[data-sc-image]');
    const unitButtons = root.querySelectorAll('.asili-sizechart__unit');
    const chartTabButtons = root.querySelectorAll('[data-sc-chart-tab]');
    const fitTipEl = root.querySelector('[data-sc-tip-fit]');

    if (modelEl) modelEl.textContent = chart.title;
    if (colWidth) colWidth.textContent = `Width (${unit === 'cm' ? 'cm' : 'in'})`;
    if (colLength) colLength.textContent = `Length (${unit === 'cm' ? 'cm' : 'in'})`;
    if (fitTipEl) fitTipEl.textContent = SIZE_CHART_TIPS[key] || SIZE_CHART_TIPS.default;

    if (tbody) {
      tbody.innerHTML = chart.rows
        .map((row) => `
          <tr>
            <td><strong>${row.size}</strong></td>
            <td>${formatMeasure(row.width, unit)}</td>
            <td>${formatMeasure(row.length, unit)}</td>
          </tr>
        `)
        .join('');
    }

    const imageUrl = SIZE_CHART_IMAGES[key];
    if (imageWrap && imageEl) {
      if (imageUrl) {
        imageEl.src = imageUrl;
        imageEl.alt = `${chart.title} measurement guide`;
        imageWrap.hidden = false;
      } else {
        imageWrap.hidden = true;
      }
    }

    unitButtons.forEach((btn) => btn.classList.toggle('is-active', btn.dataset.unit === unit));

    chartTabButtons.forEach((btn) => {
      const isActive = btn.dataset.sizeChartKey === key;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  };

  const initSizeChartWidget = (root) => {
    if (!root || root.dataset.asiliInit === 'true') return;
    root.dataset.asiliInit = 'true';
    root.dataset.unit = getPreferredUnit();

    const modal = root.closest('modal-dialog');
    if (modal) modal.classList.add('asili-sizechart-modal');

    root.querySelectorAll('.asili-sizechart__unit').forEach((btn) => {
      btn.addEventListener('click', () => {
        const unit = btn.dataset.unit === 'cm' ? 'cm' : 'in';
        root.dataset.unit = unit;
        setPreferredUnit(unit);
        renderSizeChart(root);
      });
    });

    root.querySelectorAll('[data-sc-chart-tab]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const nextKey = (btn.dataset.sizeChartKey || '').trim().toLowerCase();
        if (!SIZE_CHARTS[nextKey]) return;

        root.dataset.sizeChartStaticKey = nextKey;
        renderSizeChart(root);
      });
    });

    renderSizeChart(root);
  };

  const initSizeCharts = (scope = document) => {
    scope.querySelectorAll?.('[data-asili-sizechart]').forEach(initSizeChartWidget);
  };

  onReady(() => {
    scheduleProxyPosition();
    initSizeCharts(document);
  });

  window.addEventListener('load', scheduleProxyPosition);
  window.addEventListener('resize', scheduleProxyPosition);
  window.addEventListener('pageshow', () => {
    scheduleProxyPosition();
    initSizeCharts(document);
  });

  document.addEventListener('click', (event) => {
    const proxy = event.target.closest?.('#asiliSizeChartProxy');
    if (!proxy) return;
    event.preventDefault();
    openSizeChart();
  }, true);

  document.addEventListener('variant:change', scheduleProxyPosition, true);
  document.addEventListener('product:variant-change', scheduleProxyPosition, true);
  document.addEventListener('product-info:loaded', (event) => {
    scheduleProxyPosition();
    initSizeCharts(event.target || document);
  });
  document.addEventListener('shopify:section:load', (event) => {
    scheduleProxyPosition();
    initSizeCharts(event.target || document);
  });
  document.addEventListener('shopify:section:select', scheduleProxyPosition);

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('[name^="options"]') || event.target?.closest?.('variant-selects') || event.target?.closest?.('product-form')) scheduleProxyPosition();
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target?.matches?.('input[type=radio]') || event.target?.closest?.('.swatch') || event.target?.closest?.('[role="option"]')) scheduleProxyPosition();
  }, true);

  const observerRoot = document.querySelector('main') || document.body;
  if (observerRoot) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('[data-asili-sizechart]')) initSizeChartWidget(node);
          if (node.querySelector?.('[data-asili-sizechart]')) initSizeCharts(node);
          if (node.matches?.(PRODUCT_INFO_SELECTOR) || node.querySelector?.(PRODUCT_INFO_SELECTOR)) scheduleProxyPosition();
        }
      }
    });

    observer.observe(observerRoot, { childList: true, subtree: true });
  }
})();
